/**
 * 全局配置项
 * @Description:用于设置全局固定参数值
 *
 * @Author: JZT.Oscar
 * @Date: 2018-09-26 19:46:50
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2018-11-19 17:17:45
 */

// COOKIES 配置项
const CookieConf = {
    // 登录 Cookie 名称
    loginCookieName: "RZ_TOKEN",
    // COOKIE 过期时间(小时)
    loginCookieExpires: 3,
    // 记住登录信息:Cookie 名称
    rememberCookieName: "RZ_REMEMBER_INFO",
    // 记住登录信息:Cookie 过期时间
    rememberCookieExpires: 24 * 30,
    // 记住登录信息:Cookie 分割字符串
    rememberCookieSplitChars: "%*|*%",
    // 一级域名
    domain: ".jk.com"
};

// 环境配置项
const EnvConf = {
    // Mock Server 设置
    mockServer: {
        enabled: false,
        baseUrl: "http://doc.yyjzt.com/mock/5bac7246244c953aa11234a4/"
    },
    prod: {
        domain: "www.jk.com",
        service: "www.jk.com"
    },
    pre: {
        domain: "third.pre.jk.com",
        service: "third.pre.jk.com"
    },
    dev: {
        // 网站域名
        domain: "wyc-test.yun-sk.com/",
        // 接口域名
        service: "wyc-test.yun-sk.com/"
    },
    test2: {
        // 网站域名
        domain: "sale.third.test.jk.com",
        // 接口域名
        service: "sale.third.test.jk.com"
    }
};

export { CookieConf, EnvConf };



// WEBPACK FOOTER //
// ./src/libs/config.js